/** @jsx jsx */

import { jsx, css } from '@emotion/core';

import { Colors, Spacing } from '@zapier/theme';
import { createKeyHandler } from '@zapier/common-utils';

import Icon from 'app/common/components/Icon';

import type { ID } from 'app/common/types';

const danger = Colors.status.error.border;

const Styles = {
  root: css`
    display: inline-flex;
    cursor: pointer;
    align-items: center;
    vertical-align: middle;
    color: ${danger};
    margin-top: ${Spacing.small}px;
  `,
  staleAuthLabelIcon: css`
    margin-right: ${Spacing.extraSmall}px;
  `,
  staleAuthLabelTextBase: css`
    margin-right: ${Spacing.extraSmall}px;
    display: inline-block;
  `,
  staleAuthLabelText: css`
    text-decoration: none;
  `,
};

type Props = {
  selectedAuthId: ID | number;
  onReconnectAuth: (id: ID | number) => void;
};

const AuthReconnectButton = ({ selectedAuthId, onReconnectAuth }: Props) => (
  <span
    css={Styles.root}
    onClick={() => onReconnectAuth(selectedAuthId)}
    onKeyDown={createKeyHandler(['enter'], () =>
      onReconnectAuth(selectedAuthId)
    )}
    role="button"
    tabIndex={0}
  >
    <Icon css={Styles.staleAuthLabelIcon} type="alert" />
    <span css={Styles.staleAuthLabelTextBase}>This account is expired.</span>
    <span css={Styles.staleAuthLabelText}>Please reconnect it here</span>.
  </span>
);

export default AuthReconnectButton;
